import { applianceType, mode } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';


export class NLY extends LegrandModule {
    measures_scope?: string;

    get fieldApplianceType() {
        return applianceType(this.appliance_type);
    }

    get fieldMode() {
        return mode(this.measures_scope);
    }

    get shouldShowDevice() {
        return !this.deviceIdIncludesHash;
    }
}
